import { render, staticRenderFns } from "./set_mail_move.vue?vue&type=template&id=26830f33&scoped=true&"
import script from "./set_mail_move.vue?vue&type=script&lang=js&"
export * from "./set_mail_move.vue?vue&type=script&lang=js&"
import style0 from "./set_mail_move.vue?vue&type=style&index=0&id=26830f33&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26830f33",
  null
  
)

export default component.exports